/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 添加批量编辑照片页面埋点 Hook
 * @LastEditors: yingongjing
 * @LastEditTime: 2026-01-26 19:20:31
 */

import { useCallback } from 'react'
import { useAppSelector } from '../../../../../app/hooks'
import sensors, { sensorsRole } from '../../../../../utils/sensors'
import dayjs from 'dayjs'

// 定义 actionType 类型
type ActionType =
  | 'enterPage'
  | 'chooseOne'
  | 'unChooseOne'
  | 'chooseAll'
  | 'unChooseAll'
  | 'back'
  | 'closeBackPop'
  | 'confirmBackPop'
  | 'clickPhotoTime'
  | 'clickPhotoMember'
  | 'clickPhotoPlace'
  | 'clickWatermar'
  | 'clickReset'
  | 'clickFilter'
  | 'clickSearch'
  | 'complete'
  | 'clickPhotoKeyword'
  | 'clickPhotoLocation'
  | 'clickPhotoMember'

// 埋点参数接口
interface TrackParams {
  actionType: ActionType
  show_watermark_list?: string[] // 水印列表
  searchWord?: string // 搜索词
  locationName?: string // 拍摄地点
  photoNum?: number // 选择照片总数（actionType = complete时上报）
  start_date?: string // 拍照时间筛选开始日期 yyyy-MM-dd
  end_date?: string // 拍照时间筛选截止日期 yyyy-MM-dd
}

/**
 * 添加批量编辑照片页面埋点 Hook
 * 返回埋点函数，自动填充公共参数（groupID、role等）
 */
export const useAddPhotosTrack = () => {
  // 获取公共埋点参数
  const groupID = useAppSelector((state) => state.group.groupId)
  const myRole = useAppSelector((state) => state.group.myRole)
  const role = sensorsRole(myRole)

  /**
   * 添加批量编辑照片页面埋点函数
   */
  const trackAddPhotos = useCallback(
    (params: TrackParams) => {
      sensors.track('workgroup_b7748_c7749_click', {
        requirement_id: 513,
        track_sign: 'aworkgroup.b7748.c7749.click.workgroup_b7748_c7749_click',
        actionType: params.actionType,
        show_watermark_list: params.show_watermark_list || [],
        searchWord: params.searchWord || '',
        locationName: params.locationName || '不限',
        photoNum: params.photoNum,
        role,
        groupID: groupID || '',
        start_date: params.start_date || '',
        end_date: params.end_date || ''
      })
    },
    [groupID, role]
  )

  return { trackAddPhotos, groupID, role }
}

/**
 * 格式化日期为 yyyy-MM-dd
 */
export const formatDate = (date: dayjs.Dayjs | null): string => {
  return date ? dayjs(date).format('YYYY-MM-DD') : ''
}
